import loglevel from 'loglevel';
import { GRAPHQL_API_CONFIGURATION, GRAPHQL_API_KEY } from 'constants';
import { AIRINGS, AIRING, VOD, NETWORKS } from 'queries';
import { Api } from 'enums';
import { queryString } from 'lib/format';
import toAbsoluteURL from 'lib/url-adapter/toAbsoluteURL';
import { newRelicEmitter, UNFULFILLED_PROMISE_EVENT} from 'lib/metrics/newRelicEventBus';
import request from './cache/requestCache';
import proxy from './requestProxy';
import fallback from './cache/fallbackCache';

const { Env: ApiEnv } = Api;

const log = loglevel.getLogger('GraphQL');

export const config = {
    basePath: '/api'
};

export const getServiceUrl = (env = ApiEnv.PROD) => {
    return toAbsoluteURL(GRAPHQL_API_CONFIGURATION[env].serviceUrl);
};

export const getBaseUrl = (env = ApiEnv.PROD) => {
    return `${getServiceUrl(env)}${config.basePath}`;
};

export function getNetworks({
   lang,
   apiEnv,
   variables
}) {
    return makeRequest({
        lang,
        apiEnv,
        query: NETWORKS,
        variables
    });
}

export function getAirings({
   lang,
   apiEnv,
   variables
}) {
    return makeRequest({
        lang,
        apiEnv,
        query: AIRINGS,
        variables
    });
}

export function getAiring({
   lang,
   apiEnv,
   variables
}) {
    return makeRequest({
        lang,
        apiEnv,
        query: AIRING,
        variables
    });
}

export function getVideo({
    lang,
    apiEnv,
    variables
}) {
    return makeRequest({
        lang,
        apiEnv,
        query: VOD,
        variables
    });
}

export function makeRequest({
    lang,
    apiEnv,
    query,
    variables
}) {
    const qs = queryString({
        query: query.replace(/\n/g, '').replace(/^(\s+)|(\s+)$/g, '').replace(/(\s+)/g, ' '),
        variables: JSON.stringify(variables),
        apiKey: GRAPHQL_API_KEY
    }, true);
    const url = `${getBaseUrl(apiEnv)}${qs}`;
    log.debug(`makeRequest: ${url}`);

    return request.get(url)
        .set('Accept-Language', lang)
        .use(proxy)
        .then(({ body }) => {
            if (body.errors) {
                if (body.errors[0]) {
                    const err = new Error(body.errors[0].message);
                    log.error(`makeRequest: ${url}`, err.message);
                    newRelicEmitter.emit(UNFULFILLED_PROMISE_EVENT, err);
                }
                return body;
            }
            fallback.set(url, body);
            return body;
        })
        .catch((err) => {
            log.error(`makeRequest: ${url}`, err.status);
            newRelicEmitter.emit(UNFULFILLED_PROMISE_EVENT, err);
            // make sure response is not `null`, so we can use default assignment
            return fallback.get(url).then(response => response || {});
        });
}



// WEBPACK FOOTER //
// ./app/lib/api/GraphQL.js